import { newLogoReachOk64 } from 'reports/base64Images';
import { groupBy } from 'selectors/generic';
import store from 'source/store';
import theme from 'source/theme';
import { shortDate } from 'utils/helperFunctions/dateFormat';

// `product.product_flows` - which flows a product is on.
const productFlowsByProduct = groupBy('productFlows', 'product_id');

const themeLight = theme.palette.primary.light;
const lightGrey = '#EEEEEE';
const productHeader = [
  { text: '', fillColor: themeLight },
  { text: 'Fluxo / Produto', fillColor: themeLight },
  { text: 'Perigoso', fillColor: themeLight }
];

const rowGenerator = (products, flows) => {
  const rows = [];

  const flowsOf = productFlowsByProduct(store.getState());

  flows.forEach(flow => {

    rows.push([
      { text: flow.code, fillColor: lightGrey },
      { text: flow.name, fillColor: lightGrey },
      { text: '', fillColor: lightGrey }
    ]);

    // Still a walk over products, because the rows have to come out in the
    // order products arrived in; only the test inside it became a lookup.
    const productsInFlow = products.filter(p =>
      (flowsOf[p.id] || []).map(fp => fp.flow_id).includes(flow.id)
    );
    productsInFlow.forEach(pif => {
      rows.push([
        { text: pif.code },
        { text: pif.name },
        { text: pif.hazardous ? 'x' : '' }
      ]);
    });

  });
  return rows;

};

const dd = (products, flows) => ({
  pageSize: 'A4',
  pageMargins: [40, 60, 40, 40],

  footer: function (currentPage, pageCount) {
    return {
      text: `${shortDate(new Date())} - ${currentPage.toString()} de ${pageCount}`,
      alignment: 'right',
      relativePosition: { x: -15, y: 20 },
      fontSize: 7
    };
  },
  header: function (currentPage, pageCount, pageSize) {
    return [
      {
        image: newLogoReachOk64,
        width: 50,
        relativePosition: { x: 20, y: 10 }
      }
    ];
  },
  content: [
    {
      style: 'header',
      text: 'R - Produtos por Fluxograma' //title,
    },
    {
      style: 'tableExample',
      layout: 'lightHorizontalLines',
      table: {
        headerRows: 1,
        widths: [100, '*', 100],
        body: [
          productHeader,
          ...rowGenerator(products, flows)
        ]
      }
    }
  ],
  styles: {
    header: {
      color: theme.palette.primary.main,
      fontSize: 16,
      bold: true,
      alignment: 'center'
    },
    tableExample: {
      margin: [0, 15, 0, 0],
      fontSize: 8
    }
  }

});

export default dd;
